<template>
  <a-spin tip="loading" v-if="loading" id="loading" size="large">
    <div class="spin-content"></div>
  </a-spin>
  <div class="working-wall-detail" v-else ref="classTwo">
    <header>
      <a-row class="header">
        <a-col :span="3" class="header-right">
          <i @click="$router.go(-1)"></i>
        </a-col>
        <a-col :span="18" class="header-title">
          <span>{{ $t("workingWall.AssignmentDetails") }}</span>
        </a-col>
      </a-row>
    </header>
    <!--  -->
    <div :class="is_show ? 'pos_top' : ''">
      <div class="row" @touchmove.prevent>
        <div class="row-img">
          <img
            :src="datas.avatar != '' ? datas.avatar : defaultImg"
            alt
            :onerror="errorImg"
          />
        </div>
        <div class="row-right">
          <h1>{{ datas.resources_name }}</h1>
          <div class="row-bottom">
            <div class="row-bottom-one">
              <span class="row-name">{{ datas.username }}</span>
              {{ $t("workingWall.Postedat") }}
              <span>{{ datas.created_at }}</span>
            </div>
            <div class="row-bottom-two">
              <div class="row-click">
                <i></i>
                {{ datas.click_num }}
              </div>
              <div class="row-praise" @click="praise">
                <i :class="datas.is_praise == 0 ? 'unpraise' : 'praised'"></i>
                {{ datas.praise_num }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pos">
        <div class="detail">
          <div class="title">{{ $t("workingWall.AssignmentDetails") }}</div>
          <div class="btn" @click="show_des">
            {{ text }}
            <i class="down"></i>
          </div>
        </div>
        <div class="des" v-show="is_show" @touchmove.prevent>
          <div class="bg-color">
            <div class="first-des">
              <div class="title">
                <i class="dotted"></i>
                {{ $t("workingWall.AssignmentDes") }}
              </div>
              <p v-if="datas.info != ''">{{ datas.info }}</p>
            </div>
            <div class="first-des second-des" v-if="datas.homework_url != ''">
              <div class="title">
                <i class="dotted"></i>
                {{ $t("workingWall.AssignmentSee") }}
                <span
                  v-if="
                    datas.file_extension == 'zip' ||
                    datas.file_extension == 'rar'
                  "
                >
                  <i></i>
                  {{ $t("workingWall.AssignmentNotSup") }}
                </span>
              </div>

              <div
                :class="
                  datas.file_extension == 'zip' || datas.file_extension == 'rar'
                    ? 'unname'
                    : 'name'
                "
                @click="go_detail(datas.file_extension, datas.homework_url)"
                v-text="
                  datas.file_name == ''
                    ? $t('workingWall.Enclosure')
                    : datas.file_name
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="block"></div>
      </div>

      <div class="content" v-if="type == 1">
        <div class="title">{{ $t("workingWall.Answer") }}</div>
        <p>{{ datas.answer }}</p>
      </div>
      <!-- <div class="title_ans">{{ $t("workingWall. Answer") }}</div> -->
      <div
        v-if="type == 2"
        :class="is_show ? 'content-pdf-pos' : 'content-pdf'"
      >
        <!-- <div class="title">{{$t('workingWall. Answer')}}</div> -->
        <MyAlipdf
          :url="{ url: datas.file_url }"
          :urlParams="urlParams"
        ></MyAlipdf>
        <!-- <watermark v-if="moveRange" :position="moveRange"></watermark> -->
      </div>
      <div
        v-if="type == 3"
        :class="is_show ? 'content-pdf-pos' : 'content-pdf'"
      >
        <!-- <div class="title">{{$t('workingWall. Answer')}}</div> -->
        <!-- <div class="pdf"> -->
        <iframe
          :src="iframeUrl"
          frameborder="0"
          height="100%"
          width="100%"
          allowtransparency="true"
        ></iframe>
        <!-- <watermark v-if="moveRange" :position="moveRange"></watermark> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="detail-bottom">
      <router-link
        tag="div"
        class="more-comment"
        :to="{ path: '/main/commentList', query: { id: datas.id } }"
      >
        <img src="../../assets/img/working-wall/more_k.png" />
        {{ $t("workingWall.MoreComments") }}
      </router-link>
      <router-link
        tag="div"
        class="write-comment"
        :to="{
          path: '/main/add_question',
          query: { id: datas.id, from: 'working_wall' },
        }"
      >
        <img src="../../assets/img/working-wall/comment_w.png" />
        {{ $t("workingWall.WriteAComment") }}
      </router-link>
    </div>
  </div>
</template>
<script>
import MyAlipdf from "components/MyAlipdf/index1.vue";
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
import { static_pdf_URL } from "../../api/global_variable";
import { mapState } from "vuex";
export default {
  components: {
    MyAlipdf,
  },
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      loading: true,
      datas: [],
      type: 0,
      urlParams: {
        url: "http://img.dev.eceibs.net/document/intest/vector/8809801e50694b848dba7a5d3dd0e78d",
      },
      repeat_praise: true,
      iframeUrl: "",
      moveRange: "",
      text: this.$t("workingWall.more"),
      is_show: false,
    };
  },
  computed: {
    ...mapState({
      praised: (state) => state.working_wall.praised,
    }),
  },
  created() {
    this.get_detail();
  },
  mounted() {},
  methods: {
    show_des() {
      if (this.text == this.$t("workingWall.more")) {
        this.is_show = true;
        this.text = this.$t("workingWall.collapse");
        $(".btn").addClass("hoverd");
        $(".btn").find("i").removeClass("down").addClass("up");
      } else {
        this.is_show = false;
        this.text = this.$t("workingWall.more");
        $(".btn").removeClass("hoverd");
        $(".btn").find("i").removeClass("up").addClass("down");
      }
    },
    go_detail(type) {
      // console.log(type);
      if (type == "zip" || type == "rar") {
        this.$toast(this.$t("workingWall.AssignmentNotSup"));
      } else {
        this.$router.push({
          name: "sub_alfx_detail_yl",
          query: {
            fileUrl: this.datas.homework_url,
          },
        });
      }
    },
    get_detail() {
      var url = "index.php/mobile/homework/get-wall-detail";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        id: this.$route.query.id,
      };
      this.$axios.post(url, params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.datas = res.data.result;
          this.get_type(res.data.result.file_ext);
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    get_type(ext) {
      if (ext == "") {
        // txt
        this.type = 1;
      } else {
        if (this.datas.file_url.indexOf("pdf?auth_key") != -1) {
          // pdf不是向量模式
          this.type = 3;
          this.iframeUrl = `${static_pdf_URL}/pdf/web/viewer.html?file=${encodeURIComponent(
            this.datas.file_url
          )}`;
        } else {
          this.type = 2;
        }
      }
    },
    praise() {
      if (this.repeat_praise) {
        this.repeat_praise = false;
        // }
        var url = "index.php/mobile/homework/wall-praise";
        var params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          item_id: this.datas.id,
          trainplan_id: this.datas.trainplan_id,
        };
        this.$axios.post(url, params).then((res) => {
          // console.log(res);
          this.repeat_praise = true;
          if (res.data.code == 0) {
            if (res.data.result.is_praise == 1) {
              this.datas.praise_num++;
              this.datas.is_praise = 1;
              this.$store.commit("working_wall/praised", 1); // 点赞了，列表页要加1
            } else {
              if (this.datas.praise_num > 0) {
                this.datas.praise_num--;
              }
              this.datas.is_praise = 0;
              this.$store.commit("working_wall/praised", 0); // 取消点赞了，列表页要加-1
            }
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.working-wall-detail {
  // width: 100%;
  height: 100%;
}
header {
  height: 0.7rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
}
.pos_top {
  //展开时
  position: fixed;
  left: 0;
  right: 0;
}
.pos1 {
  height: calc(100% - 1.1rem);
}
.row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  margin: 0.4rem 0.3rem 0;
  padding-bottom: 0.4rem;
  .row-img {
    img {
      width: 0.76rem;
      height: 0.76rem;
      border-radius: 50%;
      margin-right: 0.17rem;
      pointer-events: none; //防止图片点击放大
    }
  }
  .row-right {
    width: 100%;
    h1 {
      font-size: 0.4rem;
      font-weight: bold;
    }
    .row-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.07rem;
      .row-bottom-one {
        font-size: 0.22rem;
        .row-name {
          color: #005587;
          display: inline-block;
          max-width: 1.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: top;
        }
      }
      .row-bottom-two {
        display: flex;
        align-items: center;
        .row-click {
          margin: 0 0.2rem;
          font-size: 0.22rem;
          i {
            display: inline-block;
            width: 0.33rem;
            height: 0.25rem;
            background: url("../../assets/img/working-wall/see@2x.png")
              no-repeat center/contain;
            background-size: 100%;
            vertical-align: middle;
            margin-top: -0.05rem;
          }
        }
        .row-praise {
          font-size: 0.22rem;
          i {
            display: inline-block;
            width: 0.33rem;
            height: 0.25rem;
          }
          .unpraise {
            background: url("../../assets/img/working-wall/fav@2x.png")
              no-repeat center/contain;
            background-size: 75%;
            // vertical-align: middle;
          }
          .praised {
            background: url("../../assets/img/working-wall/faved@2x.png")
              no-repeat center/contain;
            background-size: 75%;
            // vertical-align: middle;
          }
        }
      }
    }
  }
}
.pos {
  position: relative;
  .detail {
    padding: 0.4rem 0;
    margin: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .title {
      font-size: 0.3rem;
      color: #252631;
    }
    .btn {
      padding: 0.02rem 0.16rem;
      font-size: 0.22rem;
      color: #005587;
      border: 1px solid #005587;
      border-radius: 0.25rem;
      i {
        display: inline-block;
        height: 0.15rem;
        width: 0.1rem;
        margin-left: 0.05rem;
      }
      .down {
        background: url("../../assets/img/column_video/show.png") no-repeat
          center/contain;
        background-size: 100%;
      }
      .up {
        background: url("../../assets/img/working-wall/up.png") no-repeat
          center/contain;
        background-size: 100%;
      }
    }
    .hoverd {
      color: #fff;
      background: #005587;
    }
  }
  .des {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 9999999999;
    width: 100%;
    height: 100%;
    .bg-color {
      background-color: #fff;
      padding: 0.4rem 0.3rem;
    }
    .first-des {
      .title {
        font-size: 0.3rem;
        color: #252631;
        padding-bottom: 0.28rem;
        .dotted {
          display: inline-block;
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background: #000;
          margin-right: 0.2rem;
          vertical-align: middle;
        }
      }
      p {
        font-size: 0.26rem;
        padding-bottom: 0.4rem;
      }
    }
    .second-des {
      padding: 0.4rem 0;
      border-top: 1px solid #ddd;
      span {
        font-size: 0.22rem;
        color: #f75d5d;
        i {
          display: inline-block;
          width: 0.22rem;
          height: 0.22rem;
          background: url("../../assets/img/learning_camp/undone.png") no-repeat
            center/contain;
          background-size: 100%;
          margin: 0 0.05rem;
        }
      }
      .name {
        border: 1px solid #005587;
        color: #005587;
        font-size: 0.28rem;
        padding: 0.1rem 0.3rem;
      }
      .unname {
        border: 1px solid #ddd;
        color: #999;
        font-size: 0.28rem;
        padding: 0.1rem 0.3rem;
      }
    }
  }
}
.detail-bottom {
  display: flex;
  background: #005587;
  width: 100%;
  height: 0.9rem;
  position: fixed;
  bottom: 0;
  left: 0;
  color: #fff;
  font-size: 0.28rem;
  padding: 0.25rem 0;
  z-index: 9999999999;
  .more-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    border-right: 1px solid #fff;
    img {
      width: 0.27rem;
      height: 0.05rem;
      margin-right: 0.15rem;
    }
  }
  .write-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    img {
      width: 0.32rem;
      height: 0.3rem;
      margin-right: 0.15rem;
      vertical-align: middle;
    }
  }
}
.content {
  padding: 0.3rem;
  .title {
    font-size: 0.3rem;
    color: #252631;
    margin-bottom: 0.2rem;
  }
  p {
    font-size: 0.28rem;
    margin-bottom: 0.9rem;
  }
}
.title_ans {
  font-size: 0.3rem;
  color: #252631;
  margin: 0.3rem 0.4rem 0.2rem 0.4rem;
}
.content-pdf {
  position: absolute;
  margin: 0.4rem 0.4rem;
  height: 100%;
  width: 90%;
  margin-bottom: 2rem;
}
//展开时pdf absolute
.content-pdf-pos {
  //展开时
  position: fixed;
  margin: 0 0.4rem;
  height: 100%;
  width: 90%;
}
</style>
